import { Component, OnInit } from '@angular/core';
import { DashCodeHelper } from '@app/_shared/_helpers/dashcode.helper';
import { GlobalHelper } from '@app/_shared/_helpers/global.helper';

@Component({
  selector: 'dashlayout-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  thisYear = new Date().getFullYear();
  constructor(public dashcodeHelper:DashCodeHelper,public globalHelper:GlobalHelper) {}

  ngOnInit(): void {
  }

}
